import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { ProgramForm } from '../../components/programs/ProgramForm';
import { useTenant } from '../../hooks/useTenant';

export function ProgramCreatePage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { organization } = useTenant();

  const handleSubmit = async (data: Record<string, unknown>) => {
    setIsLoading(true);
    try {
      const { data: newProgram, error } = await supabase
        .from('programs')
        .insert([{ ...data, organization_id: organization?.organization_id }])
        .select()
        .single();

      if (error) throw error;
      navigate(`/programs/${newProgram!.id}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <Link to="/programs" className="text-gray-400 hover:text-gray-600">
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Create Program</h1>
          <p className="mt-1 text-sm text-gray-500">
            Define a new program or initiative for your organization
          </p>
        </div>
      </div>

      {/* Form */}
      <ProgramForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}
